import type { DestinationResource } from "@prequel/import-react";
import { useListDestinations } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Type", "Created"];

export const TYPE_LABELS: Record<string, string> = {
  webhook_record: "HTTP Record",
  webhook_batch: "HTTP Batch",
};

const mapDestinationToRow = (dest: DestinationResource): TableRow => ({
  id: dest.id,
  to: `/import/destinations/${dest.id}`,
  cells: [
    { value: dest.name },
    { value: TYPE_LABELS[dest.type] ?? dest.type },
    { value: <Timestamp timestamp={dest.created_at} /> },
  ],
});

const DestinationsTable = () => {
  return (
    <ResourceTable<DestinationResource>
      columns={COLUMNS}
      useQuery={useListDestinations}
      rowMapper={mapDestinationToRow}
      emptyMessage="No destinations configured."
    />
  );
};

export default DestinationsTable;
